import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { StoreLayout } from './components/StoreLayout.jsx';
import { Toaster } from './components/Toaster.jsx';
import { BasketProvider } from './context/BasketContext.jsx';
import { CurrencyProvider } from './context/CurrencyContext.jsx';
import { StoreConfigProvider } from './context/StoreConfigContext.jsx';
import { StoreUIProvider } from './context/StoreUIContext.jsx';
import { ToastProvider } from './context/ToastContext.jsx';
import { CategoryPage } from './pages/CategoryPage.jsx';
import { HomePage } from './pages/HomePage.jsx';

// The admin panel is a separate audience and a large chunk of the bundle, so
// shoppers never download it.
const AdminApp = lazy(() =>
  import('./admin/AdminApp.jsx').then((module) => ({ default: module.AdminApp })),
);

// Home and category are where shoppers land, so they ship in the main bundle.
// The rest are detours — split them out rather than making every first visit
// pay for the legal copy and the order-confirmation screen.
const named = (loader, name) => lazy(() => loader().then((m) => ({ default: m[name] })));

const LegalPage = named(() => import('./pages/LegalPage.jsx'), 'LegalPage');
const NotFoundPage = named(() => import('./pages/NotFoundPage.jsx'), 'NotFoundPage');
const OrderPage = named(() => import('./pages/OrderPage.jsx'), 'OrderPage');
const TermsPage = named(() => import('./pages/TermsPage.jsx'), 'TermsPage');

export function App() {
  return (
    <ToastProvider>
      <StoreConfigProvider>
        <CurrencyProvider>
          <BasketProvider>
            <StoreUIProvider>
              <Suspense fallback={null}>
                <Routes>
                  <Route element={<StoreLayout />}>
                    <Route path="/" element={<Navigate to="/home/" replace />} />
                    <Route path="/home" element={<HomePage />} />
                    <Route path="/home/" element={<HomePage />} />
                    <Route path="/categories/:slug" element={<CategoryPage />} />
                    <Route path="/categories/:slug/" element={<CategoryPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/terms/" element={<TermsPage />} />
                    <Route path="/legal" element={<LegalPage />} />
                    <Route path="/legal/" element={<LegalPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                  </Route>

                  <Route path="/order/:orderId" element={<OrderPage />} />

                  <Route path="/admin/*" element={<AdminApp />} />
                </Routes>
              </Suspense>

              <Toaster />
            </StoreUIProvider>
          </BasketProvider>
        </CurrencyProvider>
      </StoreConfigProvider>
    </ToastProvider>
  );
}
